import { FC } from "react";
import PersonalGptView from "./PersonalGptView";

const PersonalGptHandler : FC = () => {
    return <PersonalGptView />
}

export default PersonalGptHandler;